// @flow

import * as React from 'react';

import type { TranslatorProps } from '@gandi/translate';
import { Base } from '@gandi/ui';

type Props = {
  translator: TranslatorProps,
  orgName: string,
};

function ResellerDisclaimer(props: Props): React.Node {
  const {
    translator: { __ },
    orgName,
  } = props;

  return (
    <Base padding="small" backgroundColor="surface">
      <p>
        {__(
          'A reseller is a specific profile of companies purchasing and managing Gandi products for customers via %(orgName)s.',
          { orgName },
        )}
      </p>
      <p>
        {__(
          "Domains managed by a reseller-type organization are only accessible to the reseller. It is not possible to grant access to the domain's owner directly to allow them to manage the domain.",
        )}
      </p>
      <p
        dangerouslySetInnerHTML={__(
          'If you want your customers to be able to access their products directly, then we recommend making use of organizations and teams, as opposed to the reseller model. <a href="https://docs.gandi.net/en/reseller/reseller_benefits/reseller_vs_organization.html" rel="external noopener noreferrer" target="_blank" >Learn more</a>',
          { withHTML: true },
        )}
      />
      <p>
        {__(
          'A reseller organization cannot be charged to a non-reseller organization later.',
        )}
      </p>
    </Base>
  );
}

export default (React.memo<Props>(
  ResellerDisclaimer,
  () => true,
): React.ComponentType<Props>);
